import { useEffect } from 'react'

const useBrowserTabTitles = (title) => {
  useEffect(() => {
    document.title = `${title} - LSL Client Portal`
  })
}

export default useBrowserTabTitles
